<template>
    <div v-if="hasAccess">
        <top-nav-bar :goto="backPath"></top-nav-bar>
        <div class="border rounded mx-4">
            <div class="p-2 uppercase font-bold font-heading relative flex items-center cursor-pointer"
                 @click="show_rules = !show_rules">
                Annual Leave Rules
                <div class="ml-auto">
                    <span v-if="!show_rules">Show</span>
                    <span v-if="show_rules">Hide</span>
                </div>
            </div>
            <div class="pa1 ft4" v-if="show_rules">
                <ul class="list-reset p-4">
                    <li class="mb-4 pl-6 relative">
                        <span class="pin-l absolute font-bold">§</span>
                        Each prioritized bid is equal to one full week (Monday-Sunday: 7 days).
                    </li>
                    <li class="mb-4 pl-6 relative">
                        <span class="pin-l absolute font-bold">§</span>
                        Using “And”/”Or” conditions, you are able to configure your request as intended:    
                        <ul class="ml2 mt1">
                            <li class="mb2"><strong>“Or”</strong> to be used for prioritization of any single (one) week requests.
                            </li>
                            <li class="mb2"><strong>“And”</strong> to be used for prioritization of two or more weeks’ requests.
                            </li>
                        </ul>
                    </li>
                    <li class="mb-4 pl-6 relative">
                        <span class="pin-l absolute font-bold">§</span>
                        If you submit more than one request, only the latest request before deadline will apply.
                    </li>
                    <li class="mb-4 pl-6 relative">
                        <span class="pin-l absolute font-bold">§</span>
                        If you need to submit an odd number of days, you need to contact Local HR.
                    </li>
                </ul>
            </div>
        </div>
        <form v-if="request && annual_leave" @submit.prevent="save">
            <div class="pt-2 pb-8">
                <h4 class="mb-10 text-lg">
                    <span class="pb-2 ml-4 border-b-4 border-blue">{{request.name || 'Add Request'}}</span>
                </h4>

                <div class="flex" v-for="(bid, index) in request.bid">
                    <div class="flex-1 px-4">
                        <form-group :name="'bid.'+index+'.option'" label="Option">
                            <div class="select">
                                <select v-model="bid.option" class="input">
                                    <option :value="null">--</option>
                                    <option v-for="option in getOptions(bid.option)" v-text="option"></option>
                                </select>
                            </div>
                        </form-group>
                    </div>

                    <div class="w-1/3 md:w-1/5 px-4" v-if="(index+1) !== annual_leave.number">
                        <form-group :name="'bid.'+index+'.condition'" label="Condition">
                            <div class="select">
                                <select v-model="bid.condition" class="input">
                                    <option value="and">AND</option>
                                    <option value="or">OR</option>
                                </select>
                            </div>
                        </form-group>
                    </div>
                </div>

                <div class="block md:inline-flex md:float-right px-4 mt-4">
                    <button class="btn btn--colored__green w-full" type="submit">
                        <i class="fal fa-check"></i>
                        Save
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import InteractsWithDates from '@/mixins/InteractsWithDates'
    import CanAccessView from "../mixins/CanAccessView";

    export default {
        mixins: [InteractsWithDates, CanAccessView],

        data() {
            return {
                annual_leave: null,
                show_rules: false,
                request: {
                    id: '',
                    name: '',
                    bid: [
                        {
                            option: null,
                            condition: 'and'
                        }
                    ],
                },
                url: ''
            }
        },

        mounted() {
            this.url = `annual-leave/${this.$route.params.annual_leave}`;
            if (this.$route.params.request) {
                this.url += `/${this.$route.params.request}`;
                this.$api('hr').get(this.url)
                    .then(({data}) => {
                        this.request = data.data.request;
                    })
            }

            this.$api('hr').get(`annual-leave`)
                .then(({data}) => {
                    this.annual_leave = data.data;
                    if (!this.$route.params.request) {
                        let bid = []
                        for (let index = 0; index < this.annual_leave.number; index++) {
                            bid.push({option: null, condition: 'and'})
                        }
                        this.request.bid = bid
                    }
                })
        },

        computed: {
            backPath() {
                let path = '/annual-leave';

                // if (this.$route.params.request) {
                //     return `/${path}/${this.$route.params.annual_leave}/${this.$route.params.request}`;
                // }

                return path;
            }
        },

        methods: {
            getOptions(current) {
                return this.annual_leave.options.map(({option}) => option)
            },

            addAnnualLeaveRequestBid() {
                this.request.bid.push({option: null, condition: 'and'});
            },

            removeAnnualLeaveRequestBid(index) {
                this.request.bid = this.request.bid.filter((element, i) => {
                    return i !== index
                })
            },

            save() {
                this.$api('hr').post(this.url, {bid: this.request.bid})
                    .then(() => {
                        this.$router.push('/annual-leave');
                    });
            },
        }
    }
</script>
